import { render, staticRenderFns } from "./index-companyList.vue?vue&type=template&id=7963b15e&scoped=true"
import script from "./index-companyList.vue?vue&type=script&lang=js"
export * from "./index-companyList.vue?vue&type=script&lang=js"
import style0 from "./index-companyList.vue?vue&type=style&index=0&id=7963b15e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7963b15e",
  null
  
)

export default component.exports